<script>
import axios from 'axios';
import config from '../config.js';

export default {
    data() {
        return {
            loading: true,
            selectedDocument: null,
            drawer: false,
            documents: [
            ],
            sharepointContextMenuItems: [
                { title: 'Share', action: "share" },
                { title: 'Download', action: "download" },
                { title: 'Delete', action: "delete" },
            ],
            sharePointShareDialog: false,
            shareLinkCopied: false,
            sharePointDeleteErrorFileLocked: false,
            sharePointDeleteSuccess: false,
            showChatBot: false,
            input: '',
            messages: [],
            isTyping: false,
            pathBreadcrumbs: ['Home'],
            fetchingDocuments: false,
            toShare: ''
        };
    },
    props: {
        isMobile: {
            type: Boolean,
            required: true,
        },
    },
    created() {
        document.title = 'DISlog Sharepoint'
        this.fetchDocuments();
        console.debug('isMobile: ' + this.isMobile)
    },
    methods: {
        formatDate(date) {
            return date.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })
                + ' ' + date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
        },
        getIconColorByExtension(fileName, type) {
            const extension = fileName.split('.').pop();
            if (type === 'folder') {
                return '#FFBE20';
            }
            else if (extension === 'doc' || extension === 'docx') {
                return '#185ABD';
            }
            else if (extension === 'ppt' || extension === 'pptx') {
                return '#C43E1C';
            }
            else if (extension === 'xls' || extension === 'xlsx') {
                return '#1D6F42';
            }
            else {
                return '#000000';
            }
        },
        close() {
            this.$router.push('/');
        },
        getIconByExtension(fileName, type) {
            const extension = fileName.split('.').pop();
            if (type === 'folder') {
                return 'mdi-folder';
            }
            else if (extension === 'doc' || extension === 'docx') {
                return 'mdi-file-word-outline';
            }
            else if (extension === 'ppt' || extension === 'pptx') {
                return 'mdi-file-powerpoint-outline';
            }
            else if (extension === 'xls' || extension === 'xlsx') {
                return 'mdi-file-excel-outline';
            }
            else {
                return 'mdi-file-document-outline';
            }
        },
        async fetchDocuments(eventFolder = undefined, back = false) {
            this.fetchingDocuments = true;
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Token not found in localStorage');
                }

                let params = '';
                if (back) {
                    if (eventFolder != this.pathBreadcrumbs[0]) {
                        const index = this.pathBreadcrumbs.indexOf(eventFolder);
                        if (index !== -1) {
                            params = '?p='
                            params += this.pathBreadcrumbs.slice(1, index + 1).join('/');
                            params.slice(0, -1);
                        }
                    }
                    const index = this.pathBreadcrumbs.indexOf(eventFolder);
                    this.pathBreadcrumbs = index !== -1 ? this.pathBreadcrumbs.slice(0, index + 1) : this.pathBreadcrumbs;
                }
                else if (eventFolder != undefined) {
                    this.pathBreadcrumbs = eventFolder.parentPath.split('/').filter(part => part !== '');
                    this.pathBreadcrumbs.push(eventFolder.title)
                    this.pathBreadcrumbs.unshift('Home')
                    params = `?p=${eventFolder.parentPath}/${eventFolder.title}`
                }

                const response = await axios.get(`${config.baseURL}/api/v1/sharepoint/${params}`, {
                    headers: {
                        Authorization: `Token ${token}`
                    }
                });

                const documents = response.data.items.map(d => ({
                    id: d.id,
                    icon: this.getIconByExtension(d.name, d.type),
                    iconColor: this.getIconColorByExtension(d.name, d.type),
                    type: d.type,
                    title: d.name,
                    modified: this.formatDate(new Date(d.lastModifiedDateTime)),
                    modified_by: d.lastModifiedBy,
                    downloadUrl: d.downloadUrl,
                    driveId: d.driveId,
                    parentPath: d.parentPath,
                    webUrl: d.webUrl
                }));

                this.documents = documents;
                this.loading = false;
            } catch (error) {
                console.error(error);
            }
            this.fetchingDocuments = false;
        },
        async openDocument(document) {
            if (document.title.endsWith('docx') || document.title.endsWith('pptx') || document.title.endsWith('xlsx') || document.title.endsWith('doc') || document.title.endsWith('ppt') || document.title.endsWith('xls')) {
                const url = document.webUrl;
                window.open(url, '_blank');
            }
            else {
                const url = document.downloadUrl;
                window.open(url, '_blank');
            }
        },
        async sharepointContextMenuOnclick(action) {
            if (action === "download") {
                console.log("download");

                const res = this.documents.find(element => element.id === this.selectedDocument);
                console.debug(res.downloadUrl);
                window.open(res.downloadUrl);
            }
            else if (action === "share") {
                console.log("share");
                const res = this.documents.find(element => element.id === this.selectedDocument);
                if (res.type != 'folder') {
                    this.toShare = res.downloadUrl;
                }
                else {
                    this.toShare = res.webUrl;
                }
                this.sharePointShareDialog = true;
            }
            else if (action === "delete") {
                try {
                    const token = localStorage.getItem('token');
                    if (!token) {
                        throw new Error('Token not found in localStorage');
                    }

                    const res = this.documents.find(element => element.id === this.selectedDocument);

                    const response = await axios.delete(`${config.baseURL}/api/v1/sharepoint/`, {
                        headers: {
                            Authorization: `Token ${token}`
                        },
                        data: {
                            id: res.id
                        },
                    });

                    this.sharePointDeleteSuccess = true;
                    this.fetchDocuments();
                } catch (error) {
                    console.error(error.response);
                    if (error.response.status == 423) {
                        this.sharePointDeleteErrorFileLocked = true;
                    }
                }

            }
        },
        simulateTypingResponse(text) {
            let i = 0;
            const typingSpeed = 10;
            const addChar = () => {
                if (i < text.length) {
                    this.messages.push({ text: text.slice(0, i + 1), from: 'bot' });
                    if (i > 0) this.messages.splice(this.messages.length - 2, 1);
                    i++;
                    this.chatScrollToBottom();
                    setTimeout(addChar, typingSpeed);
                } else {
                    this.isTyping = false;
                }
            };
            setTimeout(addChar, typingSpeed);
        },
        async onShare() {
            try {
                await navigator.clipboard.writeText(this.toShare);
                this.shareLinkCopied = true;
                setTimeout(() => {
                    this.shareLinkCopied = false;
                }, 2000);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
        onChatBot() {
            this.showChatBot = true;
            this.simulateTypingResponse('Do you have any questions regarding the Sharepoint?');
        },
        chatScrollToBottom() {
            const container = this.$el.getElementsByClassName('chat-content-divider')[0];
            if (container) {
                container.scrollIntoView({ top: 0, behavior: 'smooth' });
            }
        },
        async sendMessage() {
            if (this.input.trim() === '') return;

            this.messages.push({ text: this.input, from: 'user' });
            this.chatScrollToBottom();

            const url = `${config.baseURL}/api/v1/fast-bot/`;

            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token not found in localStorage');
            }

            const headers = {
                headers: {
                    Authorization: `Token ${token}`
                }
            }

            const data = {
                user_message: this.input,
            };

            try {
                this.isTyping = true;
                this.chatScrollToBottom();
                this.input = '';


                const response = await axios.post(url, data, headers);
                this.isTyping = false;
                this.simulateTypingResponse(response.data.message);
                this.chatScrollToBottom();

            } catch (error) {
                this.simulateTypingResponse('There was an error. Please try again...');
                //console.error('Error:', error.response ? error.response.data : error.message);
            }
        },
    }
};

</script>

<template>
    <v-container style="height: 100%; width: 100vmax; max-width: 2500px; position: relative;" class="justify-center pa-0">
        <v-container class="align-center" v-if="loading">
            <v-progress-circular color="#006D94" indeterminate></v-progress-circular>
        </v-container>
        <v-container class="ml-0 align-center pa-0" fluid style="width:100%" v-if="!loading">
            <v-bottom-sheet v-model="showChatBot" inset>
                <v-card>
                    <v-card-text>
                        <br>
                        <br>
                        <v-card class="chat-window w-100">
                            <v-card-text class="chat-content" ref="scrollContainer">
                                <div class="message align-center"
                                    :style="{ flexDirection: message.from === 'user' ? 'row-reverse' : 'row' }"
                                    v-for="(message, index) in messages" :key="index">
                                    <v-avatar class="avatar" v-if="message.from === 'user'">
                                        <v-img src="https://randomuser.me/api/portraits/men/85.jpg" contain />
                                    </v-avatar>
                                    <div :class="`bubble message ${message.from === 'user' ? 'user' : 'bot'}`">
                                        {{ message.text }}
                                    </div>
                                </div>
                                <div v-if="isTyping" class="typing-animation">
                                    <span v-for="(index, i) in 3" :key="index" class="dot"
                                        :style="{ animationDelay: `${i * 0.3}s`, backgroundColor: i === 1 ? '#333' : '#000' }"></span>
                                </div>
                                <div class="chat-content-divider mt-2"></div>
                            </v-card-text>
                            <v-card-actions>
                                <v-text-field v-model="input" label="Message" append-icon="mdi-send"
                                    @click:append="sendMessage" @keyup.enter="sendMessage"
                                    class="input-field"></v-text-field>
                            </v-card-actions>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-bottom-sheet>
            <v-snackbar v-model="sharePointDeleteSuccess" multi-line>
                Success!
                <template v-slot:actions>
                    <v-btn color="green" variant="text" @click="sharePointDeleteSuccess = false">
                        Close
                    </v-btn>
                </template>
            </v-snackbar>
            <v-snackbar v-model="sharePointDeleteErrorFileLocked" multi-line>
                Cannot delete file: The file you want to delete is currently opened by you or another user.
                <template v-slot:actions>
                    <v-btn color="red" variant="text" @click="sharePointDeleteErrorFileLocked = false">
                        Close
                    </v-btn>
                </template>
            </v-snackbar>
            <v-dialog v-model="sharePointShareDialog" width="auto">
                <v-card max-width="1000px" prepend-icon="mdi-share"
                    text="Copy the following link to share the file with others." title="Share">
                    <v-card-text>
                        <v-list-item class="w-100">
                            <v-text-field class="pt-5" :value="toShare" density="compact" variant="solo" hide-details
                                single-line>
                                <template v-slot:append>
                                    <v-icon v-if="!shareLinkCopied" @click="onShare">
                                        mdi-content-copy
                                    </v-icon>
                                    <v-icon v-if="shareLinkCopied" color="green">
                                        mdi-check
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-list-item>
                    </v-card-text>
                    <template v-slot:actions>
                        <v-btn class="ms-auto" text="Ok" @click="sharePointShareDialog = false"></v-btn>
                    </template>
                </v-card>
            </v-dialog>
            <v-container class="w-100">
                <!--<v-app-bar color="white">
                    <template v-slot:prepend>
                        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
                        <v-avatar color="#178387" rounded="0">
                            <span>DB</span>
                        </v-avatar>
                    </template>

                    <v-app-bar-title>Test</v-app-bar-title>

                    <template v-slot:append>
                        <v-btn variant="text" class="text-lowercase">
                            <v-icon icon="mdi-account" />
                            <span class="pl-2">1 member</span>
                        </v-btn>
                    </template>
                </v-app-bar>-->
                <!--<v-navigation-drawer v-model="drawer">
                    <v-list-item active-class="bg-primary" class="mt-4" link title="Home" to="/"></v-list-item>
                    <v-list-item active-class="bg-primary" link title="Chats" to="/chats"></v-list-item>
                    <v-list-item active-class="bg-primary" link title="Documents" to="/documents"></v-list-item>
                    <v-list-item active-class="bg-primary" link title="Recycle bin" to="/recycle-bin"></v-list-item>
                </v-navigation-drawer>-->
                <v-container class="w-100 pa-0 h-100">
                    <v-container class="pa-0" color="white">
                        <v-container class="pa-2">
                            <v-row class="d-flex align-center justify-center">
                                <v-btn prepend-icon="mdi-plus" variant="flat" color="primary"
                                    class="text-capitalize ma-1">
                                    New
                                </v-btn>
                                <v-btn prepend-icon="mdi-comment-processing-outline" variant="flat" color="primary"
                                    class="text-capitalize ma-1" @click="onChatBot">
                                    Ask AI
                                </v-btn>
                                <div class="ml-8" v-if="!isMobile">
                                    <v-btn icon="mdi-arrow-collapse-up" variant="text" color="primary" />
                                    <v-btn icon="mdi-filter-outline" variant="text" color="primary" />
                                    <v-btn icon="mdi-information-outline" variant="text" color="primary" />
                                    <v-btn icon="mdi-arrow-expand" variant="text" color="primary" />
                                </div>
                            </v-row>
                            <v-row class="d-flex align-center justify-center" style="color: black">
                                <span>Path: </span>
                                <v-breadcrumbs :items="pathBreadcrumbs">
                                    <template #item="{ item }">
                                        <span class="folder" @click="fetchDocuments(item.title, true)">{{ item.title
                                            }}</span>
                                    </template>
                                </v-breadcrumbs>
                            </v-row>
                        </v-container>
                        <v-container class="mt-2" v-if="isMobile">
                            <v-row class="d-flex align-center justify-center">
                                <v-btn icon="mdi-arrow-collapse-up" variant="text" color="primary" />
                                <v-btn icon="mdi-filter-outline" variant="text" color="primary" />
                                <v-btn icon="mdi-information-outline" variant="text" color="primary" />
                                <v-btn icon="mdi-arrow-expand" variant="text" color="primary" />
                            </v-row>
                        </v-container>
                    </v-container>
                    <v-divider class="my-none mt-4" />
                    <v-container class="pa-0">
                        <v-list lines="one">
                            <v-list-item>
                                <v-row>
                                    <v-col cols="6">
                                        <v-icon icon="mdi-file-outline" />
                                        <span class="pl-3 font-weight-bold">Name</span>
                                        <v-icon icon="mdi-chevron-down" size="sm" />
                                    </v-col>
                                    <v-col cols="4">
                                        <span class="font-weight-bold">Modified</span>
                                        <v-icon icon="mdi-chevron-down" size="sm" />
                                    </v-col>
                                    <v-col cols="2">
                                        <span class="font-weight-bold">By</span>
                                        <v-icon icon="mdi-chevron-down" size="sm" />
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-divider />
                            <div v-if="documents.length === 0">
                                <span v-if="documents.length === 0" style="font-style: italic;">Empty folder</span>
                            </div>
                            <v-container class="align-center" v-if="fetchingDocuments">
                                <v-progress-linear color="#006D94" height="4" indeterminate rounded></v-progress-linear>
                            </v-container>
                            <div v-if="!fetchingDocuments" v-for="(document, index) in documents" :key="index">
                                <v-list-item class="cursor-pointer" @click="selectedDocument = document.id"
                                    :style="{ backgroundColor: selectedDocument === document.id ? '#ebebeb' : '' }">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-row>
                                                <v-col cols="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-left">
                                                            <v-icon v-if="selectedDocument !== document.id"
                                                                icon="mdi-check-circle" color="#FFFFFF" size="xs"
                                                                class="mr-2" />
                                                            <v-icon v-if="selectedDocument === document.id"
                                                                icon="mdi-check-circle" color="#4F6BEE" size="xs"
                                                                class="mr-2" />
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col cols="2">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-left">
                                                            <v-icon :icon="document.icon" :color="document.iconColor" />
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col cols="6">
                                                    <div class="wrap-text">
                                                        <div class="text-left">
                                                            <span class="folder"
                                                                @click="document.type === 'folder' ? fetchDocuments(document) : openDocument(document)">{{
                                                                    document.title
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col cols="2">
                                                    <div v-if="selectedDocument === document.id">
                                                        <v-menu>
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn size="x-small" icon="mdi-dots-horizontal"
                                                                    variant="text" v-bind="props"></v-btn>
                                                            </template>
                                                            <v-list>
                                                                <v-list-item
                                                                    v-for="(item, i) in sharepointContextMenuItems"
                                                                    :key="i" :value="i"
                                                                    @click="sharepointContextMenuOnclick(item.action)">
                                                                    <v-list-item-title>{{ item.title
                                                                        }}</v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="4" class="wrap-date">
                                            <span>{{ document.modified }}</span>
                                        </v-col>
                                        <v-col cols="2" class="wrap-text">
                                            <span>{{ document.modified_by }}</span>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                                <v-divider />
                            </div>
                        </v-list>
                    </v-container>
                </v-container>
            </v-container>
        </v-container>
    </v-container>
</template>

<style scoped>
.folder:hover {
    text-decoration: underline;
    cursor: pointer;
}

.wrap-date {
    word-wrap: break-word;
    white-space: normal;
}

.wrap-text {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    word-break: break-all;
}

.chat-window {
    max-height: 600px;
    overflow: hidden;
    overflow-y: auto;
    background: rgba(255, 255, 255, 0.4) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 16px;
}

.chat-content {
    display: flex;
    flex-direction: column;
    max-height: 450px;
    overflow-y: auto;
}

.message {
    display: flex;
    margin-top: 10px;
    text-align: left;
}

.avatar {
    margin-top: 10px;
    margin-left: 10px;
}

.bubble {
    padding: 10px 20px;
    border-radius: 20px;
    color: white;
    max-width: 60%;
    word-wrap: break-word;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.15);
}

.bot {
    background: rgba(0, 109, 148, 0.75);
}

.user {
    background: rgba(173, 173, 173, 0.7);
}

.input-field {
    width: 100%;
}

.typing-animation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    margin-left: 10px;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 3px;
    opacity: 0.4;
    animation: typing 1s infinite;
}

@keyframes typing {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}
</style>